import { get, post } from '@/lib/api/client';
import { ENDPOINTS } from '@/constants/endpoints';

import type {
  AuthenticateRequest,
  AuthenticationResponse,
  AuthUser,
  ChangePasswordRequest,
} from '../types/auth';

export const authService = {
  login: async (data: AuthenticateRequest): Promise<AuthenticationResponse> => {
    return post<AuthenticationResponse>(ENDPOINTS.AUTH.LOGIN, data);
  },

  changePassword: async (data: ChangePasswordRequest): Promise<void> => {
    return post<void>(ENDPOINTS.AUTH.CHANGE_PASSWORD, data);
  },

  getMe: async (): Promise<AuthUser> => {
    return get<AuthUser>(ENDPOINTS.AUTH.ME);
  },

  refreshToken: async (
    token: string,
  ): Promise<{ accessToken: string; refreshToken: string }> => {
    return post<{ accessToken: string; refreshToken: string }>(
      ENDPOINTS.AUTH.REFRESH,
      { refreshToken: token },
    );
  },

  loginMicrosoft: async (token: string): Promise<AuthenticationResponse> => {
    return post<AuthenticationResponse>(ENDPOINTS.AUTH.MICROSOFT, {
      accessToken: token,
    });
  },
};
